export const handleDate = (dateString: string) => {
  const localDate = new Date(dateString).toLocaleDateString("en-CA");
  return localDate;
};

export const handleDateWithTime = (dateString: string) => {
  const localDateTime = new Date(dateString).toLocaleString("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return localDateTime;
};
